import { combineReducers } from "redux";

import auth from "./auth.js";
import project from "./project.js";
import review from "./review.js";


export default combineReducers({
 
  auth,

  project,
  review
 
});